import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone, FiHelpCircle } from '../Icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Defined Home Services</h3>
            <p className="text-sm text-gray-600 mb-4">
              Your comprehensive CRM solution for managing home service businesses efficiently.
            </p>
            <div className="flex space-x-4">
              <a href="https://definedcleaning.com" target="_blank" rel="noopener noreferrer" 
                 className="text-gray-600 hover:text-gray-900">
                Website
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/getting-started" className="text-sm text-gray-600 hover:text-gray-900">
                  Getting Started
                </Link>
              </li>
              <li>
                <Link to="/categories" className="text-sm text-gray-600 hover:text-gray-900">
                  All Features
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-gray-600 hover:text-gray-900">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/troubleshooting" className="text-sm text-gray-600 hover:text-gray-900">
                  Troubleshooting
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Topics */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Popular Topics</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/articles/appointments" className="text-sm text-gray-600 hover:text-gray-900">
                  Managing Appointments
                </Link>
              </li>
              <li>
                <Link to="/articles/invoices" className="text-sm text-gray-600 hover:text-gray-900">
                  Creating Invoices
                </Link>
              </li>
              <li>
                <Link to="/articles/customers" className="text-sm text-gray-600 hover:text-gray-900">
                  Customer Management
                </Link>
              </li>
              <li>
                <Link to="/articles/estimates" className="text-sm text-gray-600 hover:text-gray-900">
                  Generating Estimates
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Support */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Need Help?</h3>
            <div className="space-y-3">
              <a href="mailto:support@definedcleaning.com" 
                 className="flex items-center space-x-2 text-sm text-gray-600 hover:text-gray-900">
                <FiMail className="h-4 w-4" />
                <span>support@definedcleaning.com</span>
              </a>
              <a href="tel:+1234567890" 
                 className="flex items-center space-x-2 text-sm text-gray-600 hover:text-gray-900">
                <FiPhone className="h-4 w-4" />
                <span>(123) 456-7890</span>
              </a>
              <Link to="/contact" 
                    className="flex items-center space-x-2 text-sm text-gray-600 hover:text-gray-900">
                <FiHelpCircle className="h-4 w-4" />
                <span>Contact Support</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-600">
              © {currentYear} Defined Home Services. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-sm text-gray-600 hover:text-gray-900">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-gray-600 hover:text-gray-900">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;